import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ConversationIdGenerator {

  private static readonly CONVO_KEY = 'conversationId';

  generateConversationId(): string{
    let convoId = sessionStorage.getItem(ConversationIdGenerator.CONVO_KEY);
    if(convoId){
      return convoId;
    }
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      const convId = crypto.randomUUID();
      sessionStorage.setItem(ConversationIdGenerator.CONVO_KEY, convId);
      return convId;
    }
    throw new Error('UUID generation not supported in this environment.');
  }

  popConversationId(): string{
    const convoId = sessionStorage.getItem(ConversationIdGenerator.CONVO_KEY);
    if(convoId){
      sessionStorage.removeItem(ConversationIdGenerator.CONVO_KEY);
      return convoId;
    }
    throw new Error('No conversation ID found in session storage.');
  }

  removeConversationId(): boolean {
    sessionStorage.removeItem(ConversationIdGenerator.CONVO_KEY);
    return !!(sessionStorage.getItem(ConversationIdGenerator.CONVO_KEY));
  }
}
